"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 24 24" id=icon-radio-checked-24><path fill-rule=evenodd clip-rule=evenodd d="M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12s12-5.373 12-12c0-6.628-5.373-12-12-12m0 1c6.066 0 11 4.935 11 11s-4.934 11-11 11S1 18.065 1 12 5.934 1 12 1m0 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z"></path></symbol>';
}
